var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSettingsFilled = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.882 12.881a6.5 6.5 0 0 0 .057-.881c0-.3-.019-.6-.067-.881l1.956-1.482a.45.45 0 0 0 .116-.571l-1.85-3.113c-.116-.206-.357-.272-.569-.206l-2.303.9a6.9 6.9 0 0 0-1.562-.881l-.347-2.382A.46.46 0 0 0 13.85 3h-3.7a.45.45 0 0 0-.453.384L9.35 5.766a7 7 0 0 0-1.562.88l-2.303-.9a.466.466 0 0 0-.569.207l-1.84 3.113c-.116.196-.078.44.115.571l1.956 1.482c-.048.281-.086.59-.086.881 0 .29.019.6.067.881l-1.956 1.482a.45.45 0 0 0-.116.571l1.85 3.113c.116.206.357.272.57.206l2.303-.9a6.9 6.9 0 0 0 1.56.881l.348 2.382a.47.47 0 0 0 .463.384h3.7c.232 0 .425-.16.454-.384l.346-2.382a6.7 6.7 0 0 0 1.562-.88l2.303.9c.212.074.453 0 .569-.207l1.85-3.113a.426.426 0 0 0-.115-.571zM12 15.375c-1.908 0-3.47-1.519-3.47-3.375S10.092 8.625 12 8.625s3.47 1.519 3.47 3.375-1.562 3.375-3.47 3.375"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSettingsFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/settings-filled.f2bd678a.svg";